'use client';

import { ApolloProvider } from '@apollo/client';

import { client } from '@/helpers/apollo/client';
import { ShopifyTracking } from '@/helpers/client/analytics/shopify';
import { AnimateOnScroll } from '@/helpers/client/animate-on-scroll';
import { CookieConsent } from '@/helpers/client/cookie-consent';
import { useDocumentTheme } from '@/helpers/client/document-theme';
import { useStoryblok } from '@/helpers/client/storyblok';
import { CartProvider } from '@/helpers/shopify/cart';

/**
/**
 * Dynamically load on scroll animation
 */
export const Client = ({ draftModeEnabled, locale, storyTheme, children }) => {
  useDocumentTheme({ storyTheme });

  useStoryblok({ draftModeEnabled });

  return (
    <ApolloProvider client={client}>
      <CartProvider>
        {children}

        <ShopifyTracking locale={locale} />

        <AnimateOnScroll />

        {!draftModeEnabled ? <CookieConsent locale={locale} /> : null}
      </CartProvider>
    </ApolloProvider>
  );
};
